import React from 'react';

import { User } from '@vimeo/viewer';

import { AlbumThemes, Clip } from '../../types';
import { THEME_STANDARD } from '../../utils/constants';
import { getVideoId } from '../../utils/helpers';
import ClipCard from '../ClipCard';

const STANDARD_ASPECT_RATIO = 9 / 16;

interface Props {
  video: Clip;
  albumId: number;
  albumHash?: string;
  theme: AlbumThemes;
  curUser?: User;
  isOffsite: boolean;
  allowDownloads: boolean;
  setDownloadClipId?: (id: number) => void;
  openDownloadModal?: () => void;
  trackClipClick?: () => void;
}

export default function VideoCard({
  video,
  albumId,
  albumHash,
  theme = THEME_STANDARD,
  curUser,
  isOffsite,
  allowDownloads,
  setDownloadClipId,
  openDownloadModal,
  trackClipClick,
}: Props) {
  const { description, isFree, name, pictures, privacy, user } = video;

  const videoId = getVideoId(video);
  const unlistedHash = albumHash ? `?sh=${albumHash}` : '';
  const contextualLink = `/showcase/${albumId}/video/${videoId}${unlistedHash}`;

  return (
    <ClipCard
      albumId={albumId}
      albumHash={albumHash}
      clipId={videoId}
      description={description}
      isFree={isFree}
      link={contextualLink}
      name={name}
      privacy={privacy}
      theme={theme}
      user={user}
      pictures={pictures}
      curUser={curUser}
      isOffsite={isOffsite}
      allowDownloads={allowDownloads}
      setDownloadClipId={setDownloadClipId}
      openDownloadModal={openDownloadModal}
      trackClipClick={trackClipClick}
    />
  );
}
